import { render, staticRenderFns } from "./ServiceCenterViewWarehouseProducts.vue?vue&type=template&id=32647fc0"
import script from "./ServiceCenterViewWarehouseProducts.vue?vue&type=script&lang=js"
export * from "./ServiceCenterViewWarehouseProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports